export const JOB_FAILED = 'failed';
export const JOB_COMPLETED = 'completed';
export const JOB_FAILED_CODE = 500;
export const JOB_FAILED_NAME = 'JobFailedError';
